<div class="overview__image-container" *ngIf="!IsInterp">
  <div class="overview__image" *ngIf="!loading" [style.width.px]="size" [@fadeIn]>
    <img [src]="src" (click)="EdiEqImage(image)" />
    <!-- <div class="overview__eval {{evalBackground}}-bg" matTooltip="Click to edit eval">{{eval}}</div> -->
    <button class="overview__eval {{evalBackground}}-bg" matTooltip="Click to edit eval" *ngIf="eval!=undefined"
      mat-button [matMenuTriggerFor]="evalMenu">{{eval}}</button>
    <mat-menu #evalMenu="matMenu">
      <button mat-menu-item (click)="updateOverallEval('A')">A</button>
      <button mat-menu-item (click)="updateOverallEval('B')">B</button>
      <button mat-menu-item (click)="updateOverallEval('C')">C</button>
      <button mat-menu-item (click)="updateOverallEval('X')">X</button>
    </mat-menu>
  </div>
  <div class="ph-item" *ngIf="loading">
    <div class="ph-picture"></div>
  </div>
</div>

<div class="overview-card" *ngIf="IsInterp">
  <div
    class="overview-card-content"
    *ngIf="!loading"
    [@fadeIn]>
    <div class="image-section" [style.width.px]="size">
      <img
        [src]="src"
        (click)="EdiEqImage(image)" />
    </div>
    <div class="info-section">
      <div
        class="worn-box left"
        [ngClass]="'Eval-' + WorstEvalL">
        L {{WorstWornL != null ? (WorstWornL | number:'1.0-1') + '%' : '-'}}
      </div>
      <div
        class="worn-box right"
        [ngClass]="'Eval-' + WorstEvalR">
        R {{WorstWornR != null ? (WorstWornR | number:'1.0-1') + '%' : '-'}}
      </div>
      <div class="eval-label">
        Overall Interpretation Eval
      </div>
      <button
        class="overview__eval1 {{evalBackground}}-bg"
        *ngIf="eval != undefined"
        mat-button
        [matMenuTriggerFor]="evalMenu">
        {{eval}}
      </button>
      <mat-menu #evalMenu="matMenu">
        <button mat-menu-item (click)="updateOverallEval('A')">A</button>
        <button mat-menu-item (click)="updateOverallEval('B')">B</button>
        <button mat-menu-item (click)="updateOverallEval('C')">C</button>
        <button mat-menu-item (click)="updateOverallEval('X')">X</button>
      </mat-menu>

    </div>
  </div>

  <div class="ph-item" *ngIf="loading">
    <div class="ph-picture"></div>
  </div>

</div>